import { useQuery } from '@tanstack/react-query'
import { listIndeedFlexCompanies } from 'api/admin/indeedFlex/listIndeedFlexCompanies'
import { indeedFlexKeys } from './keys'

export function useIndeedFlexCompaniesQuery() {
  return useQuery({
    queryKey: indeedFlexKeys.companies(),
    queryFn: listIndeedFlexCompanies,
  })
}
